/**
 * Single source of truth for site URL.
 *
 * Priority order:
 * 1. NEXT_PUBLIC_BASE_URL (set on Vercel for Production and Development)
 * 2. VERCEL_URL (auto-injected by Vercel for preview deployments)
 * 3. Hardcoded production fallback
 *
 * All schema, OG, canonical, sitemap, and metadata URL construction
 * should use this. Never hardcode the domain elsewhere.
 */

export const SITE_URL: string = (() => {
  if (process.env.NEXT_PUBLIC_BASE_URL) {
    return process.env.NEXT_PUBLIC_BASE_URL;
  }
  if (process.env.VERCEL_URL) {
    return `https://${process.env.VERCEL_URL}`;
  }
  return 'https://leadpops.com';
})();

/**
 * Construct an absolute URL from a relative path.
 * @param path - Relative path starting with '/' (e.g., '/mortgage-leads').
 *               Leading slash is enforced if missing.
 */
export function siteUrl(path: string = ''): string {
  if (!path) return SITE_URL;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${normalizedPath}`;
}
